<div class="title_div">
  <div class="w-100 d-flex justify-content-between align-items-center">
    <div class="title_sub_div_1 title_right_icon_div">Overview</div>
    <div class="title_sub_div_1 mt-1 mr-1">
      <i class="fa fa-home" (click)="home()" title="Dashboard"></i> <!-- Home icon here -->
    </div>
  </div>
</div>
<!-- <div #target class="row row_mar"> -->
  <!-- <div class="container">
      <div class="row">
          <div class="column">
              <label for="firstName">First Name</label>
              <input type="text" id="firstName" placeholder="Enter First Name">
          </div>
          <div class="column">
              <label for="lastName">Last Name</label>
              <input type="text" id="lastName" placeholder="Enter Last Name">
          </div>
      </div>
      <div class="row">
          <div class="column">
              <label for="email">Email</label>
              <input type="email" id="email" placeholder="Enter Email">
          </div>
          <div class="column">
              <label for="phone">Phone</label>
              <input type="tel" id="phone" placeholder="Enter Phone Number">
          </div>
      </div>
      <div class="row">
          <div class="column">
              <label for="address">Address</label>
              <input type="text" id="address" placeholder="Enter Address">
          </div>
          <div class="column">
              <label for="city">City</label>
              <input type="text" id="city" placeholder="Enter City">
          </div>
      </div>
      <div class="row">
          <div class="column">
              <label for="state">State</label>
              <input type="text" id="state" placeholder="Enter State">
          </div>
          <div class="column">
              <label for="zip">ZIP Code</label>
              <input type="text" id="zip" placeholder="Enter ZIP Code">
          </div>
      </div>
  </div> -->
  
  <!-- <div class="container"> -->
  <div>
      <div class="d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <div class="form-group" title="Customer">
            <select id="customerName" class="form-select form-select-lg" aria-label="Select Customer Name"
              [(ngModel)]="selectedCustomerName" (change)="onSelectCustomer()">
              <option disabled value="" [selected]="selectedCustomerName === ''">Customer </option>
              <option *ngFor="let cus of allCustomerDetails" [value]="cus.customerName">{{ cus.customerName }}</option>
            </select>
          </div>
          <div class="form-group" title="Engineer">
            <select id="enginner" class="form-select form-select-lg" aria-label="Select Engineer Name"
              [(ngModel)]="selectedEngineer" (change)="onSelectEnginner()">
              <option disabled value="" [selected]="selectedEngineer === ''">Engineer </option>
              <option *ngFor="let cus of engineersData" [value]="cus.engineer_id">{{ cus.engineer_name }}</option>
            </select>
          </div>
          <div class="form-group" title="Stage">
            <select id="Stage" class="form-select form-select-lg" aria-label="Select Stage"
              [(ngModel)]="selectedCurrentStage" (change)="onSelectStage($event)">
              <option disabled value="" [selected]="selectedCurrentStage === ''">Select Stage</option>
              <option value="Costing" [selected]="selectedCurrentStage === 'Costing'">Costing</option>
              <option value="Procurement" [selected]="selectedCurrentStage === 'Procurement'">Procurement</option>
              <!-- <option *ngFor="let cus of allCustomerData" [value]="cus.currentStage">{{ cus.currentStage }}</option> -->
            </select>
          </div>
          <!-- <div class="form-group">
                  <select id="customerName" class="form-select form-select-lg" aria-label="Select Customer Name"
                    [(ngModel)]="selectedExpetedCompletionDate" (change)="onSelectMonthCompletion()">
                    <option disabled value="" [selected]="selectedExpetedCompletionDate === ''">Month Of Completion</option>
                    <option *ngFor="let cus of allCustomerData" [value]="cus.expetedCompletionDate">{{ cus.expetedCompletionDate }}</option>
                  </select>
                </div> -->
          <!-- <div class="form-group" title="Expeted Completion Date">
           
            <input id="completionDate" class="form-control form-control-lg" type="date"
              aria-label="Select Expected Completion Date" [(ngModel)]="selectedExpetedCompletionDate"
              (change)="onSelectCompletionDate()" title="Expeted Completion Date"/>
          </div>
      
          <div class="form-group" title="RFQ Date">
           
            <input id="rfqDate" class="form-control form-control-lg" type="date" aria-label="Select RFQ Date"
              [(ngModel)]="selectedRfqDate" (change)="onDateChange()" title="RFQ Date"/>
          </div> -->
          
    <!-- Button to trigger the ECD modal -->
    <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
      (click)="openModalECD()">ECD Date</button>

    <!-- ECD Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalECD}"
      [ngStyle]="{'display': showModalECD ? 'block' : 'none'}">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Expected Completion Date </h5>
            <button type="button" class="close" (click)="closeModalECD()">
              <span aria-hidden="true"  style="font-size: 2rem;">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" title="Expected Completion Date">
              <div style="display: flex; gap: 10px; flex-wrap: wrap;">
                <div>
                  <label for="fromExpectedCompletionDate">From</label>

                  <input id="fromExpectedCompletionDate" class="custom-date" type="date"
                    aria-label="Select Start Expected Completion Date" [(ngModel)]="fromExpectedCompletionDate"
                    (change)="onSelectCompletionDate()" />
                </div>
                <div>
                  <label for="toExpectedCompletionDate">To</label>
                  <input id="toExpectedCompletionDate" class="custom-date" type="date"
                    aria-label="Select End Expected Completion Date" [(ngModel)]="toExpectedCompletionDate"
                    (change)="onSelectCompletionDate()" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Reset Button -->
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="resetDates()">Reset</button>
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="closeModalECD()">Close</button>
          </div>
        </div>
      </div>
    </div>



    <!-- Button to trigger the RFQ modal -->
    <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
      (click)="openModalRFQ()">RFQ Date
    </button>

    <!-- RFQ Date Range Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalRFQ}"
      [ngStyle]="{'display': showModalRFQ ? 'block' : 'none'}">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">RFQ Date</h5>
            <button type="button" class="close" (click)="closeModalRFQ()">
              <span aria-hidden="true" style="font-size: 2rem;">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" title="RFQ Date Range">
              <div style="display: flex; gap: 10px; flex-wrap: wrap;">
                <div>
                  <label for="fromRfqDate">From</label>
                  <input id="fromRfqDate" class="custom-date" type="date" aria-label="Select From RFQ Date"
                    [(ngModel)]="fromRfqDate" (change)="onDateRangeChange()" />
                </div>
                <div>
                  <label for="toRfqDate">To</label>
                  <input id="toRfqDate" class="custom-date" type="date" aria-label="Select To RFQ Date"
                    [(ngModel)]="toRfqDate" (change)="onDateRangeChange()" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Reset Button -->
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="resetRfqDates()">Reset</button>
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="closeModalRFQ()">Close</button>
          </div>
        </div>

      </div>

    </div>

          <button type="button" class="btn btn-outline-primary btn-sm" style="background-color: white;" title="Reset fields" (click)="resetFields()">Reset</button>
        </div>        
      
      </div>
      <div class="d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <div class="form-group card">
            <div class="custom-card-small custom-card-open-projects">
              <div class="custom-card-content-small">
                <div class="custom-card-number-small">{{openStatusCount}}</div>
                <div class="custom-card-text-small">Open Projects</div>
              </div>
            </div>
          </div>
          <div class="form-group card">
            <div class="custom-card-small custom-card-overdue">
              <div class="custom-card-content-small">
                <div class="custom-card-number-small">{{overdueCount}}</div>
                <div class="custom-card-text-small">Over Due</div>
              </div>
            </div>
          </div>
          <div class="form-group card">
            <div class="custom-card-small custom-card-yet-to-approved">
              <div class="custom-card-content-small">
                <div class="custom-card-number-small">2</div>
                <div class="custom-card-text-small">Yet To Approved</div>
              </div>
            </div>
          </div>
          <div class="form-group card">
            <div class="custom-card-small custom-card-high-risk-parts">
              <div class="custom-card-content-small">
                <div class="custom-card-number-small">10</div>
                <div class="custom-card-text-small">High Risk Parts</div>
              </div>
            </div>
          </div>
        </div>
        <!-- We need to implement SmartSync later-->
        <!-- <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-outline-primary btn-sm" title="SmartSync" title="SmartSync">SmartSync</button>
        </div> -->
      </div>
      
      <div *ngIf="matchedCustomerData.length === 0" class="row row_mar mt-1 w-100">
        <div class="card w-100">
          <div class="card-body ">
                No data found.
            </div>
          </div>
      </div>
      <div *ngIf="matchedCustomerData.length > 0" class="row row_mar mt-1">
        <div class="col-12 grid-margin stretch-card col_pad">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive gd_main_div_mobile">
                <table class="table table-striped custom-hover">
                  <thead>
                    <tr>
                      <!-- <th>Edit</th> -->
                      <th>S.No</th>
                      <th>Project Name</th>
                      <th>Customer Name</th>
                      <th>RFQ Date</th>
                      <th>Assigned To</th>
                      <th>Assigned Date</th>
                      <th>E.C.Date</th>
                      <th>Target L.Time(W)</th>
                      <th>Ageing</th>
                      <th>Progress</th>
                      <th>Version</th>
                      <th>Status</th>
                      <th>Current Stage</th>
                      <!-- <th>Action</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let customer of matchedCustomerData; let i = index">
                      <!-- <td class="editIcon" (click)="editProjectRow(customer.project_id)">
                        <i class="fa fa-pencil-alt" aria-hidden="true" title="Edit Row Data"></i>
                      </td> -->
                      <!-- <td>{{ customer.serialNumber }}</td> -->
                      <td>{{ i+1 }}</td>
                      <td>{{ customer.projectName }}</td>
                      <!-- <td>{{ customer.customerName }}</td> -->
                      <td>{{ customer.customer_name }}</td>
                      <td>{{ customer.rfqDate | date: 'dd-MM-yyyy' }}</td>
                      <!-- <td>{{ customer.assignedTo }}</td> -->
                      <td title="{{ customer.assigned_to_name }}">
                        <!-- <select [(ngModel)]="customer.assigned_to_id" (change)="onAssignedToChange(customer)">
                                      <option *ngFor="let user of users" [value]="user">{{ user }}</option>
                                    </select> -->
                        <!-- <select [(ngModel)]="customer.assigned_to_id" [disabled]="!isRowEditing(customer.project_id)" (change)="onChangeAssignTo($event)">
                          <option *ngFor="let user of engineersData" [value]="user.engineer_id">{{ user.engineer_name}}
                          </option>
                        </select> -->
                        <!-- <select class="form-select form-select-lg" [(ngModel)]="customer.assigned_to_id" [disabled]="!isRowEditing(customer.project_id)"
                          (change)="onChangeAssignTo($event, customer)">
                          <option *ngFor="let user of engineersData" [value]="user.engineer_id">{{ user.engineer_name }}</option>
                        </select> -->
                        {{ customer.assigned_to_name }}
                      </td>
                      <td>{{ customer.assigned_date | date: 'dd-MM-yyyy' }}</td>
                      <td>{{ customer.expectedCompletionDate | date: 'dd-MM-yyyy' }}</td>
                      <td>{{ customer.targetLeadTime }}</td>
                      <td>{{ customer.ageing }}</td>
                      <!-- <td>{{ customer.progress }}</td> -->
                      <td>
                        <div class="progress-container">
                          <!-- Progress bar dynamically reflects the percentage -->
                          <mat-progress-bar *ngIf="customer.progress !== undefined && customer.progress !== null"
                            [value]="customer.progress" mode="determinate" class="progress-bar"
                            [color]="getProgressBarColor(customer.progress)">
                          </mat-progress-bar>
      
                          <!-- Display the percentage beside the progress bar -->
                          <span *ngIf="customer.progress !== undefined && customer.progress !== null">
                            <!-- {{ customer.progress }}% -->
                            {{ customer.progress }}
                          </span>
      
                          <!-- If progress is undefined or null, show 'No Status' -->
                          <span *ngIf="customer.progress === undefined || customer.progress === null">
                            No Status
                          </span>
                        </div>
                      </td>
      
                      <td title="{{ customer?.version_id }}">{{ customer?.version_id }}</td>
      
                      <td>{{ customer.status }}</td>
                      <!-- <td>{{ customer.currentstage }}</td> -->
                      <!-- <td>                         
                        <select id="stage" class="form-select form-select-lg" aria-label="Select Stage"
                          [(ngModel)]="customer.currentstage" [disabled]="!isRowEditing(customer.project_id)" (change)="onChangeStage($event)">
                          <option disabled value="" [selected]="selectedCurrentStage === ''">Select Stage</option>
                          <option value="Costing" [selected]="selectedCurrentStage === 'Costing'">Costing</option>
                          <option value="Procurement" [selected]="selectedCurrentStage === 'Procurement'">Procurement</option>
                        </select>
                      </td> -->
                      <!-- <td>
                        <select id="stage" class="form-select form-select-lg" aria-label="Select Stage" [(ngModel)]="customer.currentstage"
                          [disabled]="!isRowEditing(customer.project_id)" (change)="onChangeStage($event)">
                          <option disabled value="">Select Stage</option>
                          <option value="Costing">Costing</option>
                          <option value="Procurement">Procurement</option>
                        </select>
                      </td> -->
                      <td title="{{ customer.currentstage }}">{{ customer.currentstage }}</td>
                      <!-- <td>
                                    <button type="button" class="btn btn-primary btn-sm ml-1"  title="Save Row">Save</button>
                                  </td> -->
                      <!-- <td>
                        <button type="button" class="btn btn-primary btn-sm ml-1 saveBtn" title="Save Row"
                          [disabled]="!isRowEditing(customer.project_id)" (click)="onSaveRow(customer)">
                          Save
                        </button>
                      </td> -->
                      <!-- <td>
                                    <div
                                      class="badge"
                                      [ngClass]="{
                                        'badge-success': customer.activeStatus,
                                        'badge-danger': !customer.activeStatus
                                      }"
                                    >
                                      {{ customer.activeStatus ? 'Active' : 'Inactive' }}
                                    </div>
                                  </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
  <!-- <div class="row mt-1 mb-3 pl-2">        
      <label for="colFormLabelSm" class="col-sm-1 col-form-label col-form-label-sm">Email</label>
      <div class="col-sm-4">
          <input type="email" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm">
      </div>
  </div>
  <div class="row mb-3 pl-2">
      <label for="colFormLabelSm" class="col-sm-1 col-form-label col-form-label-sm">Email</label>
      <div class="col-sm-4">
          <input type="email" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm">
      </div>
  </div>
  <div class="row mb-3 pl-2">
      <label for="colFormLabelSm" class="col-sm-1 col-form-label col-form-label-sm">Email</label>
      <div class="col-sm-4">
          <input type="email" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm">
      </div>
  </div>
  <div class="row mb-3 pl-2">
      <label for="colFormLabelSm" class="col-sm-1 col-form-label col-form-label-sm">Email</label>
      <div class="col-sm-4">
          <input type="email" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm">
      </div>
  </div>
  
  <div class="row mb-3 pl-2">
      <label for="colFormLabelSm" class="col-sm-1 col-form-label col-form-label-sm">Email</label>
      <div class="col-sm-4">
          <input type="email" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm">
      </div>
  </div>
  <div class="row mb-3 pl-2">
      <label for="colFormLabelSm" class="col-sm-1 col-form-label col-form-label-sm">Email</label>
      <div class="col-sm-4">
          <input type="email" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm">
      </div>
  </div>
  <div class="row mb-3 pl-2">
      <label for="colFormLabelSm" class="col-sm-1 col-form-label col-form-label-sm">Email</label>
      <div class="col-sm-4">
          <input type="email" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm">
      </div>
  </div>
  <div class="row mb-3 pl-2">
      <label for="colFormLabelSm" class="col-sm-1 col-form-label col-form-label-sm">Email</label>
      <div class="col-sm-4">
          <input type="email" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm">
      </div>
  </div> -->
  
  <!-- <ng-template #customerModal let-modal>
    <div class="modal-header">
        <h6 class="modal-title">Add Customer</h6>
    </div>
    <div >
          <div class="row">
            <div class="column">
              <label for="firstName">Customer FullName</label>
              <input type="text" id="firstName" placeholder="Enter Full Name">
            </div>
            <div class="column">
              <label for="lastName">City</label>
              <input type="text" id="lastName" placeholder="Enter City">
            </div>
          </div>
          <div class="row">
            <div class="column">
              <label for="state">State</label>
              <input type="text" id="state" placeholder="Enter State">
            </div>
            <div class="column">
              <label for="zip">Country</label>
              <input type="text" id="zip" placeholder="Enter Country">
            </div>
          </div>
          <div class="row">
            <div class="column">
              <label for="state">GST Number</label>
              <input type="text" id="state" placeholder="Enter GST Number">
            </div>
            <div class="column">
             
            </div>
          </div>
  
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveCustomer()">Save</button>
      <button type="button" class="btn btn-outline-primary btn-sm" title="Close"  (click)="closeModal()">Close</button>
    </div>
  </ng-template> -->
  <ng-template #customerModal let-modal>
    <form [formGroup]="customerForm">
      <div class="modal-header">
        <h6 class="modal-title">Add Customer</h6>
      </div>
      <div>
        <div class="row">
          <div class="column">
            <label for="_customerFullName">Customer Full Name</label>
            <input
              type="text"
              id="_customerFullName"
              placeholder="Enter Full Name"
              formControlName="_customerFullName"
              class="form-control"
            />
            <small *ngIf="customerForm.get('_customerFullName')?.touched && customerForm.get('_customerFullName')?.invalid" class="text-danger">
              Full Name is required (min 2 characters)
            </small>
          </div>
          <div class="column">
            <label for="city">City</label>
            <input
              type="text"
              id="city"
              placeholder="Enter City"
              formControlName="city"
              class="form-control"
            />
            <small *ngIf="customerForm.get('city')?.touched && customerForm.get('city')?.invalid" class="text-danger">
              City is required
            </small>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <label for="state">State</label>
            <input
              type="text"
              id="state"
              placeholder="Enter State"
              formControlName="state"
              class="form-control"
            />
            <small *ngIf="customerForm.get('state')?.touched && customerForm.get('state')?.invalid" class="text-danger">
              State is required
            </small>
          </div>
          <div class="column">
            <label for="country">Country</label>
            <input
              type="text"
              id="country"
              placeholder="Enter Country"
              formControlName="country"
              class="form-control"
            />
            <small *ngIf="customerForm.get('country')?.touched && customerForm.get('country')?.invalid" class="text-danger">
              Country is required
            </small>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <label for="gstNumber">GST Number</label>
            <input
              type="text"
              id="gstNumber"
              placeholder="Enter GST Number"
              formControlName="gstNumber"
              class="form-control"
            />
            <small *ngIf="customerForm.get('gstNumber')?.touched && customerForm.get('gstNumber')?.invalid" class="text-danger">
              Enter a valid 15-digit GST Number
            </small>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveCustomer()">Save</button>
        <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
      </div>
    </form>
  </ng-template>
  
  
  <!-- <ng-template #projectModal let-modal>
    <div class="modal-header">
      <h6 class="modal-title">Add Project</h6>
    </div>
    <div>
      <div class="row">
        <div class="column">
          <label for="firstName">New Project Name</label>
          <input type="text" id="firstName" placeholder="New Project Name">
        </div>
        <div class="column">
          <label for="customerName">Customer Name</label>
          <ng-select id="customerName" [(ngModel)]="selectedCustomerName" [items]="allCustomerData"
            bindLabel="customerName" [searchable]="true" placeholder="Search or select a customer"
            (keyup)="onSearch($event)" (add)="onAddNewCustomer($event)">
          </ng-select>
          <button *ngIf="showAddCustomerButton" class="btn btn-primary mt-2 add-customer-btn"
            (click)="openCustomerModel(customerModal)">
            <i class="fa fa-plus"></i>
          </button>
        </div>   
      </div>
      <div class="row">
        <div class="column">
          <label for="email">RFQ Date</label>
          <input type="email" id="email" placeholder="RFQ Date">
        </div>
        <div class="column">
          <label for="phone">Expected Completion Date</label>
          <input type="tel" id="phone" placeholder="Expected Completion Date">
        </div>
      </div>
      <div class="row">
        <div class="column">
          <label for="address">Target L. T</label>
          <input type="text" id="address" placeholder="Target L. T">
        </div>
        <div class="column">
          <label for="city"></label>
          <button type="button" class="btn btn-primary btn-sm ml-1" title="Landing Cost"
            (click)="onLandinCost(landinCostModal)">Landing Cost</button>
        </div>
      </div>
  
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="save()">Save</button>
      <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
    </div>
  </ng-template> -->
  
  <ng-template #projectModal let-modal>
    <form [formGroup]="projectForm">
      <div class="modal-header">
        <h6 class="modal-title">Add Project</h6>
      </div>
      <div>
        <div class="row">
          <div class="column">
            <label for="firstName">New Project Name</label>
            <input type="text" id="firstName" formControlName="newProjectName" placeholder="New Project Name">
          </div>
          <div class="column">
            <label for="customerFullName">Customer Name</label>
            <ng-select class="mr-2" [items]="allCustomerDetails"
              bindLabel="customerName" bindValue="customerName" [searchable]="true"
              (keyup)="onSearch($event)" (change)="onAddNewCustomer($event)" formControlName="customerFullName">
            </ng-select>
            <button *ngIf="showAddCustomerButton" class="btn btn-primary mt-2 add-customer-btn"
              (click)="openCustomerModel(customerModal)" title="Create new customer">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <label for="rfqDate">RFQ Date</label>
            <input type="date" id="rfqDate" formControlName="rfqDate" placeholder="RFQ Date">
          </div>
          <div class="column">
            <label for="completionDate">Expected Completion Date</label>
            <input type="date" id="completionDate" formControlName="completionDate" placeholder="Expected Completion Date">
          </div>
        </div>
        <div class="row">
          <div class="column">
            <label for="targetLT">Target Lead Time(Weeks)</label>
            <input type="number" formControlName="targetLT" placeholder="Target Lead Time(Weeks)">
          </div>
          <div class="column">
            <label for="city"></label>
            <button type="button" class="btn btn-primary btn-sm ml-1" title="Landing Cost"
              (click)="onLandinCost(landinCostModal)">Landing Cost</button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-primary btn-sm" (click)="save()" title="Save">Save</button>
        <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
      </div>
    </form>
  </ng-template>
  
  <!-- <ng-template #landinCostModal let-modal>
    <div class="modal-header">
        <h6 class="modal-title">landing Cost</h6>
    </div>
    <div >
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveLandingCost()">Save</button>
      <button type="button" class="btn btn-outline-primary btn-sm" title="Close"  (click)="closeModal()">Close</button>
    </div>
  </ng-template> -->
  <ng-template #landinCostModal let-modal>
    <div class="modal-header">
      <h6 class="modal-title">Landing Cost</h6>
    </div>
    <div class="modal-body">
      <!-- Q1 -->
      <div class="form-group landing_cost_form">
        <label>
          Q-1: Do you want to calculate Landing cost for the project?
        </label>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q1Yes" name="q1" (click)="onQn1Change('yes')">
          <label class="form-check-label" for="q1Yes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q1No" name="q1" (click)="onQn1Change('no')">
          <label class="form-check-label" for="q1No">No</label>
        </div>
      </div>
  
      <!-- Q2 -->
      <div class="form-group landing_cost_form" *ngIf="showQn2">
        <label>
         Q-2: Do you want to consider Duties for calculating landing cost?
        </label>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q2Yes" name="q2" (click)="onQn2Change('yes')">
          <label class="form-check-label" for="q2Yes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q2No" name="q2" (click)="onQn2Change('no')">
          <label class="form-check-label" for="q2No">No</label>
        </div>
      </div>
      <!-- Q3 -->
      <div class="form-group landing_cost_form" *ngIf="showQn3">
        <label>
          Q-3: Is it for Export or for local consumption?
        </label>
        <select class="form-control" (change)="onQn3Change($event.target.value)">
          <option value="">Select</option>
          <option value="export">Export</option>
          <option value="local">Local Consumption</option>
        </select>
      </div>
  
      <!-- Q4 -->
      <div class="form-group landing_cost_form" *ngIf="showQn4">
        <label>
         Q-4: Do you need specific duty to be added?
        </label>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q4Yes" name="q4" (click)="onQn4Change('yes')">
          <label class="form-check-label" for="q4Yes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q4No" name="q4" (click)="onQn4Change('no')">
          <label class="form-check-label" for="q4No">No</label>
        </div>
      </div>
  
      <!-- Q5 -->
      <div class="form-group landing_cost_form" *ngIf="showQn5">
        <label>
          Q-5: Define your generic duty percentage to be considered
        </label>
        <input type="number" class="form-control" placeholder="Enter generic duty percentage">
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveLandingCost()">Save</button>
      <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
    </div>
  </ng-template>
  
  <!-- </div> -->


  